import { render } from "./TopReferrers.vue?vue&type=template&id=9aac5aaa&scoped=true"
import script from "./TopReferrers.vue?vue&type=script&lang=js"
export * from "./TopReferrers.vue?vue&type=script&lang=js"

import "./TopReferrers.vue?vue&type=style&index=0&id=9aac5aaa&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.hikeseo.co/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9aac5aaa"]])

export default __exports__